module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c92706889a3b3c9d3d6e9396e11cc50f.png";